<!--
 * @Description: app
 * @Version: 0.0.1
 * @Author: yujiangping
 * @Date: 2024-06-11 13:49:13
 * @LastEditors: yujiangping
 * @LastEditTime: 2025-06-12 13:55:18
-->
<template>
    <a-config-provider :locale="locale">
        <router-view/>
    </a-config-provider>
</template>
<script> 
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enUS from 'ant-design-vue/es/locale/en_US';

export default {
  data() {
    return {
      locale: zhCN,
    };
  },
  watch: {
    '$i18n.locale'(newVal) {
      this.locale = newVal === 'zh-CN' ? zhCN : enUS;
    },
  },
};
</script>
<style lang="less">
html,body{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-size: 14px;
}
div{
  box-sizing: border-box;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #212332;
  background: #F5F7FC;
  width: 100%;

  min-height: 100%;
  // padding-top: 58px; // header高度
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
